<template>
  <v-row class="store-list">
    <v-col class="store" cols="12" md="6" lg="4" xl="3" v-for="(store, index) in $store.state.stores.list" :key="index">

      <!-- <img class="logo" v-if="store.info.storefrontUri != null" :src="store.info.storefrontUri" /> -->
      <!-- <img class="logo" v-else :src="store.info.logoUri" /> -->
      <div class="content">
        <div class="content-box" @click="storeClicked(store)">
          <!-- <div class="content-name">{{ store.info.companyName }}</div> -->
          <div v-if="store.info.address != null" class="content-address">
            <div v-if="store.info.address.street != null">
              <span
                v-if="
                  store.info.address.unit != null && store.info.address.unit != null && store.info.address.unit != ''
                "
                >Unit {{ store.info.address.unit }}, </span
              >{{ store.info.address.street }}
            </div>
            <div v-if="store.info.address.city != null">
              {{ store.info.address.city }}
              <span v-if="store.info.address.province != null">{{ store.info.address.province }}</span>
            </div>
            <div v-if="store.info.address.tel != null || store.distanceBetween != null">
              <span>{{ store.info.address.tel }}</span>
              <!--                   <span v-if="store.distanceBetween != null" class="content-distance"
                    >{{ (store.distanceBetween / 1000).toFixed(2) }} km</span
                  > -->
            </div>

            <div
              :class="
                store.timeStatus != null && store.timeStatus.opening
                  ? 'content-business-hours'
                  : 'content-business-hours-closed'
              "
              v-if="store.timeStatus != null && store.timeStatus.businessTimeLocaleString != ''"
            >
              {{ $t(store.timeStatus.businessTimeLocaleString, store.timeStatus.businessTimeParams) }}
              <span v-if="store.timeStatus.timeZoneAbbrev != ''">({{ store.timeStatus.timeZoneAbbrev }})</span>
            </div>

            <div
              class="content-preorder-message"
              v-if="store.timeStatus != null && store.timeStatus.preorderLocaleString != ''"
            >
              {{ $t(store.timeStatus.preorderLocaleString) }}
            </div>

            <div v-if="store.distanceBetween != null" class="content-distance">
              {{ (store.distanceBetween / 1000).toFixed(2) }} km
            </div>
          </div>
        </div>
      </div>

      <div class="pl-4 text-right">
        <div v-if="info" style="width:100%;" @click="$root.locationDialog.open(store)">
          <v-icon>mdi-information-outline</v-icon>
        </div>

        <v-btn v-if="order" @click="orderClicked(store)" class="mt-2" outlined rounded small color="accent">{{
          $t("order")
        }}</v-btn>
      </div>

    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    info: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    storeClicked(store) {
      this.$emit("onStoreClick", store);
    },

    orderClicked(store) {
      this.$emit("onOrderClick", store);
    },    
  },
};
</script>

<style lang="scss" scoped>
.store-list {
  margin: 16px;

  .store {
    display: flex;

    .content {
      //margin-left: 10px;
      flex: 1 1 auto;

      .content-box {
        .content-name {
          font-size: 1em;
        }
        .content-address {
          font-size: 0.8em;
          line-height: 1.3;
        }

        .content-distance {
          //float: right;
          //right: 10px;
          color: #888888;
          font-size: 0.9em;
        }
      }

      .content-business-hours {
        margin-top: 4px;
        color: #888888;
        font-size: 0.9em;
        //color: black;
        //font-size: 0.8em;
        //padding-top: 2px;
      }

      .content-business-hours-closed {
        @extend .content-business-hours;
        color: var(--v-warning-base);
      }

      .content-preorder-message {
        //color: black;
        //font-size: 0.8em;
        word-wrap: normal;
      }
    }
  }
}
</style>
